@if (parentFormGroup && languages) {
    <ng-container [formGroup]="parentFormGroup">
        <ng-container formGroupName="{{ formGroupName }}">
            @for (language of languages; track language) {
                <div
                    class="m-form-group row"
                    [ngClass]="{ 'has-error': parentFormGroup.getFormGroup(formGroupName).get(language).showErrors }"
                >
                    <label
                        class="col-4"
                        for="{{ formGroupName }}{{ language }}"
                    >
                        {{ controlLabel | translate }} ({{ language | translateEnum: "language" }})
                    </label>
                    <div class="col-8">
                        @if (!multiline) {
                            <input
                                class="p-inputtext"
                                id="{{ formGroupName }}{{ language }}"
                                #textInput
                                formControlName="{{ language }}"
                                type="text"
                            />
                            <app-form-validation
                                [control]="parentFormGroup.getFormGroup(formGroupName).get(language)"
                                [input]="textInput"
                            />
                        } @else {
                            <textarea
                                class="p-inputtextarea"
                                id="{{ formGroupName }}{{ language }}"
                                #multilineInput
                                formControlName="{{ language }}"
                            ></textarea>
                            <app-form-validation
                                [control]="parentFormGroup.getFormGroup(formGroupName).get(language)"
                                [input]="multilineInput"
                            />
                        }
                    </div>
                </div>
            }
        </ng-container>
    </ng-container>
}
